const tsConfig = {
  logoUrl: require('../img/tslogo.png'),
  title: '腾视',
  params: 'tsnetech',
  envIsTVU: false
}

const tvuConfig = {
  logoUrl: require('../img/tvuLogo.png'),
  title: 'TVU',
  params: 'tvunetworks',
  envIsTVU: true
}

const cincConfig = {
  logoUrl: require('../img/cinclogo.png'),
  title: '智媒',
  record: '云记录平台',
  params: 'cinctech',
  envIsTVU: false
}

export function getEnvInitInfo() {
  const domainArry = document.domain.split('.');
  if (domainArry.includes('tsnetech')) {
    return tsConfig
  } else if (domainArry.includes('cinctech')) {
    return cincConfig
  } else {
    return tvuConfig
  }
}
